import { useState } from 'react'

export default function EmailCapture() {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState<'idle' | 'loading' | 'done' | 'error'>('idle')
  const [errorMsg, setErrorMsg] = useState('')

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setStatus('loading')
    setErrorMsg('')

    try {
      const res = await fetch('/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      })
      const data = await res.json()
      if (!res.ok) {
        setErrorMsg(data.error ?? 'Something went wrong.')
        setStatus('error')
      } else {
        setStatus('done')
      }
    } catch {
      setErrorMsg('Could not reach the server. Please try again.')
      setStatus('error')
    }
  }

  if (status === 'done') {
    return (
      <div className="email-capture">
        <p className="email-capture-thanks">
          You're on the list. We'll let you know when more funds and screens are added.
        </p>
      </div>
    )
  }

  return (
    <div className="email-capture">
      <p className="email-capture-label">
        Want to know when we add more funds and screens?
      </p>
      <form className="email-capture-form" onSubmit={submit}>
        <input
          type="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          aria-label="Email address"
        />
        <button type="submit" disabled={status === 'loading'}>
          {status === 'loading' ? 'Saving…' : 'Notify me'}
        </button>
      </form>
      {status === 'error' && <p className="email-capture-error">{errorMsg}</p>}
    </div>
  )
}
